import React, {useState, useContext} from "react";
import {NavLink} from "react-router-dom";

import {authPages, notAuthPages} from "./routing/config";
import {
    IdcardOutlined,
    LogoutOutlined,
    DashboardOutlined,
    ShoppingCartOutlined,
    TeamOutlined
} from "@ant-design/icons";
import {Layout, Col, Row} from "antd";

import {LOGO} from './assets/images'
import {Nav, MobileNav, MobileMenuDrawer} from "./components/Navigation";
import SiderLogo, {LogoImg} from "./components/SiderLogo";
import {useNavigate} from "react-router-dom";
import {AuthContext} from "./pages/auth/AuthContext";

const {Sider} = Layout

const {
    logout,
} = notAuthPages;

const {
    home,
    myInformation,
    newOrder,
    myPatients,
    ordersHistory,
} = authPages;

const getItem = (label, key, icon, children) => ({key, icon, children, label,});

const menuItems = [
    /* Menu builder */
    getItem(home.title, home.url, <DashboardOutlined style={{fontSize: '130%', marginRight: 20}}/>),
    getItem(newOrder.title, newOrder.url, <ShoppingCartOutlined style={{fontSize: '130%', marginRight: 20}}/>),
    getItem(ordersHistory.title, ordersHistory.url, <TeamOutlined style={{fontSize: '130%', marginRight: 20}}/>),
    getItem(myPatients.title, myPatients.url, <TeamOutlined style={{fontSize: '130%', marginRight: 20}}/>),
    getItem(myInformation.title, myInformation.url, <IdcardOutlined style={{fontSize: '130%', marginRight: 20}}/>),
    getItem(logout.title, logout.url, <LogoutOutlined style={{fontSize: '130%', marginRight: 20}}/>),
];

// make a copy of patients_menu_items and add `key` attr to each item
const hardCodedMenuItems = [...menuItems]
// Hardcode for DOD Kit for 1177 provider ID
hardCodedMenuItems.splice(
    1,
    1,
    getItem(
        <>New Order</>,
        authPages.newDodOrder.url,
        <ShoppingCartOutlined style={{fontSize: '130%', marginRight: 20}}/>
    )
)
// Hardcode for DOD Kit for 1177 provider ID


const DesktopNavigation = () => {
    /* Main navigation component. Handle all main pages in application. Extends ant `Menu` component. */

    const {authContext} = useContext(AuthContext);

    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);

    const mainMenuHandler = (args) => {
        /* Handle all clicks and navigate to needed page */
        const {keyPath} = args;
        const [url] = keyPath;
        navigate(url);
    }

    return <Row>
        <Col xs={0} sm={0} md={24} lg={24}>
            <Sider
                width={'260px'}

                style={{
                    background: '#11242f',
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                }}
                collapsed={collapsed}
                onCollapse={(value) => setCollapsed(value)}
            >
                <NavLink to={home.url}>
                    <SiderLogo
                        image_source={LOGO}
                    />
                </NavLink>

                <Nav
                    theme="dark"
                    defaultSelectedKeys={['1']}
                    mode="inline"
                    items={
                        authContext?.webProviderData?.id === 1177 || authContext?.webProviderData?.id === 1166
                            ? hardCodedMenuItems
                            : menuItems
                    }
                    onClick={mainMenuHandler}
                />
            </Sider>
        </Col>
    </Row>
}


const MobileNavigation = ({open, onClose}) => {

    /* Mobile navigation component.
    Handle all main pages in application.
    Extends from `ant `Drawer` and `Menu` components. */
    const {authContext} = useContext(AuthContext);

    const navigate = useNavigate();

    const mainMenuHandler = (args) => {
        /* Handle all clicks and navigate to needed page */
        const {keyPath} = args; // getting current `key` attr in clicked Menu Item
        const [url] = keyPath;

        onClose();  // close MobileMenu Drawer
        navigate(url);  // use `key` attr value for routing
    }

    // fix bug on mobile devices with scroll
    if (open) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "auto";
    }


    return <MobileMenuDrawer
        width={'82%'} placement="right" title={null} closable={false}
        onClose={onClose} open={open} destroyOnClose={true} maskClosable={true}
        zIndex={1000} getContainer={false}
    >

        {/*Drawer value */}
        <MobileNav
            theme="dark"
            mode="inline"
            items={
                authContext?.webProviderData?.id === 1177 || authContext?.webProviderData?.id === 1166
                    ? hardCodedMenuItems
                    : menuItems
            }
            onClick={mainMenuHandler}
        />
        <LogoImg src={LOGO}/>

    </MobileMenuDrawer>
}


export {
    DesktopNavigation, MobileNavigation,
}